import { useContext, useEffect } from 'react';
import { AppContext } from '@edx/frontend-platform/react';

import { learnerDashboardUrl } from '@src/utils';

type CatalogAppContext = {
  authenticatedUser: {
    username?: string;
  } | null;
};

type AuthenticatedHomeRedirectBaseProps = {
  children: JSX.Element;
  redirect: (url: string) => void;
};

type AuthenticatedHomeRedirectProps = {
  children: JSX.Element;
};

const redirectToUrl = (url: string) => {
  window.location.assign(url);
};

export const AuthenticatedHomeRedirectBase = ({
  children,
  redirect,
}: AuthenticatedHomeRedirectBaseProps): JSX.Element | null => {
  const { authenticatedUser } = useContext(AppContext) as CatalogAppContext;

  useEffect(() => {
    if (authenticatedUser) {
      redirect(learnerDashboardUrl());
    }
  }, [authenticatedUser, redirect]);

  if (authenticatedUser) {
    return null;
  }

  return children;
};

const AuthenticatedHomeRedirect = ({ children }: AuthenticatedHomeRedirectProps) => (
  <AuthenticatedHomeRedirectBase redirect={redirectToUrl}>
    {children}
  </AuthenticatedHomeRedirectBase>
);

export default AuthenticatedHomeRedirect;
